<!-- eslint-disable max-lines -->
<!-- eslint-disable max-lines-per-function -->
<template>
    <paper v-loading="btnloading" class="customer-mip-iframe custoemr-change-home">
        <div class="top-box">
            <!-- 标题区域 -->
            <div class="header-box">
                <h4>客户引入申请单</h4>
                <div class="header-info-crm">
                    <!-- 按钮区域 -->
                    <div class="detail-toolBar">
                        <lots-button type="primary" v-if="!detailDataLocal.flowInfo" :loading="submitFlowLoading"
                            @click="handleFlow">提交审批
                        </lots-button>
                        <lots-button type="primary" v-if="isShowBtn['save']" :loading="saveLoading"
                            @click="handleSave">保 存
                        </lots-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="customer-change-info" v-loading="detailLoading">
            <!-- 表单区域 -->
            <collapse-infos ref="upholdHealder" class="customer-change-collapse" :detailData="detailDataLocal"
                :collapse="COLLAPSE" :activeCollapses="activeCollapses" @change="handleInfosChange" v-on:data-changed="dataChanged">
                <!-- 折叠筐标题插槽 -->
                <template v-slot:collapse-title-append="{ collapseItem }">
                    <span>{{ collapseItem.title }}</span>
                </template>
                <!-- 表单字段插槽 -->
                <template v-slot:collapse-append="{ form, itemSetting }">
                     <!-- 客户名称可点击到客户详情页 -->
                    <span v-if="['customerName'].includes(itemSetting.prop)" @click="toCustomerDetail(itemSetting.customerCode)">
                        {{ form[itemSetting.prop]  ? form[itemSetting.prop] : '--' }}
                    </span>
                    <span v-else-if="['fileName'].includes(itemSetting.prop)" :title="form[itemSetting.prop]">
                        <!-- 文件上传 -->
                         <span v-if="typeData.type =='update' && isShowBtn['save']" class="upload-box">
                            <!-- 新增 -->
                              <file-upload :userCode="detailDataLocal.applicantCode" :relationId="detailDataLocal.id" :text="'上传'" @callback="(res)=>{handleUpload(res)}"></file-upload>
                         </span>
                         <div v-for="file in fileList" :key="file.fileId" class="file-list-box">
                            <span class="file-list" @click="fileActions('preview',file)">
                                {{ file.fileName }}
                            </span>
                            <span class="file-actions-btn">
                                <span @click="fileActions('download',file)" v-if="isShowBtn['save']">下载</span>
                                <span  @click="fileActions('delete',file)" v-if="isShowBtn['save']">删除</span>
                            </span>
                        </div>
                    </span>
                    <span :class="itemSetting.className" v-else-if="['creditPeriodDays', 'paymentTermDays', 'tenderDeposit', 'operationDeposit', 'acceptanceRatio'].includes(itemSetting.prop)">
                        {{ form[itemSetting.prop] ? form[itemSetting.prop] : '--' }}
                    </span>
                    <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                        {{ form[itemSetting.prop]  ? form[itemSetting.prop] : '--' }}
                    </span>
                </template>
            </collapse-infos>

            <!-- iflow区域 -->
            <el-collapse v-if="detailDataLocal.flowInfo && detailDataLocal.flowInfo.mipId" class="contract-collapse detail-more-collapse" value="mipInfo">
                <el-collapse-item title="流程信息" name="mipInfo">
                    <div class="header-operation">
                        <lots-button size="mini" type="primary" v-if="isShowBtn['submit']"
                            @click="submitMip" :loading="btnloading">
                            mip提交
                        </lots-button>
                    </div>
                    <iframe class="ifr" :src="mipUrl" v-if="!btnloading" />
                </el-collapse-item>
            </el-collapse>
        </div>
        <!-- <customerComparisonDialog ref="comparisonRef" /> -->
    </paper>
</template>

<script>
import { ref, computed, getCurrentInstance, onActivated } from '@vue/composition-api';
import { collapse, specialApprovalData } from './collapseInfosConfig.js';
import _ from 'lodash';
import paper from '@/components/core/Paper.vue';
import { Message, MessageBox } from 'element-ui';
import lotsButton from '@/components/lots/lotsButton';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import CollapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import { getNodesAndOperationApi } from '@mdm/utils/flowUtils.js';
import store from '@/store/index';
import utils from '@/components/utils/common.js';
import { getCustomerByCode } from '@/modules/mdm/api/customer/customerManage.js';
import { addCustomerIntroduction, queryFlowByIntroduction, getCustomerIntroductionDetail, uploadEnclosure,
    getEnclosurePage, deleteEnclosure } from '@/modules/mdm/api/customer/customerIntroduction.js';
import fileUpload from '../components/fileUpload/Index.vue';
import configurl from '@/config/user.env';
import { filePreview } from '@/utils/filePreview.js';
import {
    getAuthorByProcessIdApi
} from '@mdm/api/contractManage/mipIframeApi.js';
import { getCrmUserPage } from '@/api/homePageApi.js';
import { dictWithUrl } from '@/components/lots/api';

const { MAGIC_NUMBER } = utils;
const MAGIC_HEIGHT = '89'; // 顶部高度

export default {
    name: 'customerIntroductionChangeFlow',
    components: {
        paper,
        lotsButton,
        CollapseInfos,
        fileUpload
    },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const config = _.cloneDeep(collapse);
        const detailLoading = ref(false);
        const btnloading = ref(false);
        const code = ref('');
        const detailDataLocal = ref({});
        const submitFlowLoading = ref(false);
        const saveLoading = ref(false);
        const isShowBtn = computed(() => {
            const { approvalStatus } = detailDataLocal.value;
            return {
                save: ['', null, undefined, '1', '5', '6'].includes(approvalStatus?.toString()),
                submit: ['', null, undefined, '1', '3', '5', '6'].includes(approvalStatus?.toString())
            };
        });
        const activeCollapses = ref(['basicInfo', 'customerInfo', 'registerInfo']);
        // eslint-disable-next-line max-lines-per-function
        const COLLAPSE = computed(() => { // 配置项动态计算
            // 需要判断的数据
            const { ebcuCustomerType, creditPeriodDays, paymentTermDays, tenderDeposit, acceptanceRatio, operationDeposit, estimatedScale,
                settlementMethod, routeCodes = [], isHazardous, isSpecialApproval, overseasBusinessTypes = [] } = detailDataLocal.value;
            const { save } = isShowBtn.value;
            // eslint-disable-next-line max-lines-per-function
            config.forEach((v) => {
                // eslint-disable-next-line complexity, max-lines-per-function
                v.formList.forEach((v2) => {
                    if (['billTitle', 'salesProduct', 'creditPeriodDays', 'paymentTermDays', 'estimatedScale',
                        'estimatedGrossMargin', 'tenderDeposit', 'operationDeposit', 'acceptanceRatio'].includes(v2.prop)) {
                        v2.type = save ? 'input' : 'custom';
                    }
                    if (['isHazardous', 'routeCodes', 'overseasBusinessTypes', 'settlementMethod'].includes(v2.prop)) {
                        v2.type = save ? 'select' : 'custom';
                    }
                    if (['routeCodes'].includes(v2.prop) && routeCodes.length > 0) {
                        if (!Array.isArray(v2.options)) {
                            const options = [];
                            for (const key in v2.options) {
                                // eslint-disable-next-line max-depth
                                if (key) {
                                    const disabled = routeCodes.length !== 0 && ((routeCodes.includes('0') && key !== '0') || (!routeCodes.includes('0') && key === '0'));
                                    options.push({ value: key, label: v2.options[key], disabled });
                                }
                            }
                            v2.options = options;
                        }
                    }
                    if (['routeCodes'].includes(v2.prop)) {
                        v2.rule[0].required = overseasBusinessTypes.includes('0');
                    }
                    if (['applicantName', 'departmentName'].includes(v2.prop)) {
                        v2.type = save ? 'advance' : 'custom';
                    }
                    if (['customerName'].includes(v2.prop)) {
                        v2.type = save && !ctx.$route.query.customerCode ? 'advance' : 'custom';
                    }
                    if (['acceptanceRatio'].includes(v2.prop)) {
                        v2.visible = settlementMethod * 1 !== 1;
                    }
                    if (['creditPeriodDays'].includes(v2.prop)) {
                        // eslint-disable-next-line no-magic-numbers
                        v2.className = +creditPeriodDays > 90 ? 'red-text' : undefined;
                    }
                    if (['paymentTermDays'].includes(v2.prop)) {
                        v2.className = +paymentTermDays > 60 ? 'red-text' : undefined;
                    }
                    if (['tenderDeposit'].includes(v2.prop)) {
                        // eslint-disable-next-line no-magic-numbers
                        v2.className = +estimatedScale > 0 && (tenderDeposit / estimatedScale > 0.03) ? 'red-text' : undefined;
                    }
                    if (['operationDeposit'].includes(v2.prop)) {
                        // eslint-disable-next-line no-magic-numbers
                        v2.className = +estimatedScale > 0 && (operationDeposit / estimatedScale > 0.03) ? 'red-text' : undefined;
                    }
                    if (['acceptanceRatio'].includes(v2.prop)) {
                        v2.className = +acceptanceRatio > 0 ? 'red-text' : undefined;
                    }
                    if (['isHazardous'].includes(v2.prop)) {
                        v2.className = +isHazardous === 1 ? 'red-text' : undefined;
                    }
                    if (['adminSpecialApproval'].includes(v2.prop)) {
                        v2.type = adminAuth.value.includes(userCode) && +isSpecialApproval === 1 && save ? 'select' : 'custom';
                    }
                    // 如果是选择客户之后,客户类型是直客，销售产品必填
                    if (['salesProduct'].includes(v2.prop)) {
                        v2.rule[0].required = ebcuCustomerType === '1';
                    }
                });
            });

            return config;
        });
        const currentAuth = ref(false);
        const isHandleEdit = ref(false);
        const oldDetailData = ref({});
        const typeData = ref({ type: 'add' });
        const { userCode, userName } = store.getters.user;
        const adminAuth = ref([]);
        const getDc = async () => {
            await dictWithUrl('LCRM_PRIVILEGED_ROLE_LIST').then(res => {
                if (res && +res.code === 0) {
                    const { LCRM_PRIVILEGED_ROLE_LIST = {} } = res.data;
                    const listStr = LCRM_PRIVILEGED_ROLE_LIST.LCRM_CUSTOMER_INFO_INTRO;
                    adminAuth.value = listStr ? listStr.split(',') : [];
                }
            });
        };
        // eslint-disable-next-line max-lines-per-function
        const _initData = async () => {
            const { customerCode, id, type } = ctx.$route.query;
            typeData.value.type = type;
            detailLoading.value = true;
            await getDc();
            if (id) {
                btnloading.value = true;
                // 详情/审批页面
                // 审批：approve
                await getDetailById(id);
                if (detailDataLocal.value.flowInfo) {
                    await getIflowhandlers(detailDataLocal.value.flowInfo.mipId);
                }
            } else {
                // 新增页面 add
                fileList.value = [];
                if (customerCode) {
                    // 如果存在客户编码，根据客户编码查找客户信息部分
                    await getCustomerByCodeInfo(customerCode);
                }
                const applicantData = localStorage.getItem('applicantData') ? JSON.parse(localStorage.getItem('applicantData')) : undefined;
                // 如果已保存过的数据
                if (applicantData && applicantData.applicantCode) {
                    detailDataLocal.value.applicantName = applicantData.applicantName;
                    detailDataLocal.value.applicantCode = applicantData.applicantCode;
                } else {
                    detailDataLocal.value.applicantName = userName;
                    detailDataLocal.value.applicantCode = userCode;
                }
                const params = {
                    pageSize: 10,
                    pageNo: 1,
                    esusLoginName: userCode
                };
                await getCrmUserPage(params).then((res) => {
                    if (res && +res.code === 0 && res.data.list.length) {
                        const { list } = res.data;
                        detailDataLocal.value.departmentName = list[0].departmentName;
                        detailDataLocal.value.departmentCode = list[0].departmentCode;
                    }
                });
                localStorage.setItem(
                    'applicantData',
                    JSON.stringify({
                        applicantCode: userCode,
                        applicantName: userName
                    })
                );
                await handleInfosChange({ form: _.cloneDeep(detailDataLocal.value) });
            }
            detailLoading.value = false;
        };
        const getCustomerByCodeInfo = (customerCode) => {
            try {
                const params = {
                    customerCode
                };
                getCustomerByCode(params).then(res => {
                    let _data = {};
                    if (+res.code === 0 && res.data) {
                        _data = {
                            customerCode: res.data.customerCode,
                            customerName: res.data.customerName,
                            customerShortName: res.data.customerShortName,
                            ebcuNameEn: res.data.ebcuNameEn,
                            ebcuEbplCountryName: res.data.ebcuEbplCountryName,
                            ebcuEbplProvinceName: res.data.ebcuEbplProvinceName,
                            ebcuEbplCityName: res.data.ebcuEbplCityName,
                            ebcuDistrictsName: res.data.ebcuDistrictsName,
                            ebcuAddress: res.data.ebcuAddress,
                            ebcuCustomerType: res.data.ebcuCustomerType,
                            isImpExpCustomer: res.data.isImpExpCustomer,
                            ebcuEbplCountryCode: res.data.ebcuEbplCountryCode,
                            ebcuEbplProvinceCode: res.data.ebcuEbplProvinceCode,
                            ebcuEbplCityCode: res.data.ebcuEbplCityCode,
                            ebcuDistricts: res.data.ebcuDistricts,
                            salesProduct: res.data.mainProducts
                        };
                        detailDataLocal.value = Object.assign({}, detailDataLocal.value, _data);
                        handleInfosChange({ form: _.cloneDeep(detailDataLocal.value) });
                    }
                });
            } catch (error) {
                console.log('error:===', error);
            }
        };
        const getDetailById = (id) => {
            try {
                const params = { id };
                return getCustomerIntroductionDetail(params).then(async res => {
                    let _data = {};
                    if (res && +res.code === 0) {
                        if (res.data.overseasBusinessTypes.length > 0) {
                            res.data.overseasBusinessTypes = res.data.overseasBusinessTypes.map(String);
                        }
                        if (res.data.routeCodes.length > 0) {
                            res.data.routeCodes = res.data.routeCodes.map(String);
                        }
                        // res.data.isHazardous = String(res.data.isHazardous);
                        // res.data.settlementMethod = String(res.data.settlementMethod);
                        _data = res.data;
                        _data.fileName = '';
                        // 待审批/审判中/审批通过/废弃时，整单只读
                        if (['2', '3', '4', '7'].includes(res.data.approvalStatus)) {
                            typeData.value.type = 'detail';
                        }
                    } else {
                        typeData.value.type = 'detail';
                    }
                    await handleInfosChange({ form: _.cloneDeep(_data) });
                    await getFileList();
                    btnloading.value = false;
                }).catch(() => {
                    btnloading.value = false;
                });
            } catch (error) {
                console.log('error:==', error);
            }
        };
        const authorized = ref(false);
        const getIflowhandlers = async (fdId) => {
            // if (env === 'ver') {
            //     authorized.value = true;
            //     return false;
            // }
            const authorityMips = [];
            // const publicPrarms = { fdId, loginName: store.getters.user.userCode };
            let res = null;
            res = await getAuthorByProcessIdApi({ fdProcessId: [fdId], loginName: store.getters.user.userCode });
            if (+res.code === 0 && res.data && res.data.length) {
                const theData = res.data.find(item => item.fdProcessId === fdId);
                authorized.value = theData?.reader;
            }
            if (ctx.$route.query.isToOtherPersons) { // 传阅人也可以查看
                authorityMips.push(ctx.$route.query.isToOtherPersons);
            }
            authorized.value = authorized.value || authorityMips.some(item => item.includes(store.getters.user.userCode));
        };
        const dataChanged = ({ data, itemSetting, form }) => {
            if (itemSetting.prop !== 'routeCodes') return;
            if (data.includes('0')) {
                // 选择了全航线，其他航线禁选
                for (let i = 0; i < itemSetting.options.length; i++) {
                    const item = itemSetting.options[i];
                    item.disabled = item.value !== '0';
                }
            } else {
                // 选了其他航线，全航线禁选
                for (let i = 0; i < itemSetting.options.length; i++) {
                    const item = itemSetting.options[i];
                    item.disabled = item.value === '0' && data?.length !== 0;
                }
            }
        };
        // eslint-disable-next-line max-lines-per-function, complexity
        const handleInfosChange = async (formObjData = {}) => { // 表单组件编辑回调，更新本地数据
            const { targetForm, itemSetting, form } = formObjData;
            // 监控表单是否编辑过
            isHandleEdit.value = Boolean(itemSetting);
            if (!itemSetting) { // 页面初始化、刷新时走：
                detailDataLocal.value = formObjData.form;
                oldDetailData.value = _.cloneDeep(formObjData.form);
                if (detailDataLocal.value && detailDataLocal.value.flowInfo && detailDataLocal.value.flowInfo.mipId) {
                    handleCreate(); // 渲染iflow流程
                    currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.flowInfo.mipId, loginName: userCode });
                }
                if (form.settlementMethod === '1') {
                    // 结算方式为现金时
                    detailDataLocal.value.acceptanceRatio = undefined;
                }
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
                // setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.updataInitData(detailDataLocal.value);
            } else { // collapse组件编辑回调时走：
                let { creditPeriodDays, paymentTermDays, tenderDeposit, acceptanceRatio, operationDeposit, estimatedScale,
                    applicantCode, departmentCode, applicantName, departmentName, settlementMethod } = targetForm;
                if (+settlementMethod === 1) {
                    // 结算方式为现金时
                    targetForm.acceptanceRatio = undefined;
                    acceptanceRatio = undefined;
                }
                let specialApprovalReasonArr = [];
                // eslint-disable-next-line no-magic-numbers
                if (+creditPeriodDays > 90) {
                    specialApprovalReasonArr.push(specialApprovalData.creditPeriodDaysMsg);
                } else {
                    specialApprovalReasonArr = specialApprovalReasonArr.filter(item => item !== specialApprovalData.creditPeriodDaysMsg);
                }
                if (+paymentTermDays > 60) {
                    specialApprovalReasonArr.push(specialApprovalData.paymentTermDaysMsg);
                } else {
                    specialApprovalReasonArr = specialApprovalReasonArr.filter(item => item !== specialApprovalData.paymentTermDaysMsg);
                }
                // eslint-disable-next-line no-magic-numbers
                if (+estimatedScale > 0 && (tenderDeposit / estimatedScale > 0.03)) {
                    specialApprovalReasonArr.push(specialApprovalData.tenderDepositMsg);
                } else {
                    specialApprovalReasonArr = specialApprovalReasonArr.filter(item => item !== specialApprovalData.tenderDepositMsg);
                }
                // eslint-disable-next-line no-magic-numbers
                if (+estimatedScale > 0 && (operationDeposit / estimatedScale > 0.03)) {
                    specialApprovalReasonArr.push(specialApprovalData.operationDepositMsg);
                } else {
                    specialApprovalReasonArr = specialApprovalReasonArr.filter(item => item !== specialApprovalData.operationDepositMsg);
                }
                if (+acceptanceRatio > 0) {
                    specialApprovalReasonArr.push(specialApprovalData.acceptanceRatioMsg);
                } else {
                    specialApprovalReasonArr = specialApprovalReasonArr.filter(item => item !== specialApprovalData.acceptanceRatioMsg);
                }
                targetForm.specialApprovalReason = specialApprovalReasonArr.join(';');
                targetForm.isSpecialApproval = specialApprovalReasonArr.length > 0 ? 1 : 0;
                if (itemSetting.prop === 'applicantName') {
                    const params = {
                        pageSize: 10,
                        pageNo: 1,
                        esusLoginName: applicantCode
                    };
                    await getCrmUserPage(params).then((res) => {
                        if (res && +res.code === 0) {
                            const { list = [] } = res.data;
                            targetForm.departmentName = list[0]?.departmentName;
                            targetForm.departmentCode = list[0]?.departmentCode;
                        }
                    });
                    localStorage.setItem('applicantData', JSON.stringify(
                        { applicantCode, applicantName }
                    ));
                }
                if (itemSetting.prop === 'departmentName') {
                    localStorage.setItem('applicantData', JSON.stringify({ applicantCode: detailDataLocal.value.applicantCode, applicantName }));
                }
                const { relatedFiles } = detailDataLocal.value;
                // 除了插槽参数以外，其他参数取最新编辑的参数更新(因：插槽的编辑不会触发collapse组件change事件回调，因此change事件回调的插槽的参数是旧数据不能取)
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    targetForm,
                    { relatedFiles } // 保证插槽数据用最新的
                );
            }
        };
        const timer = 1800;
        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const times = setTimeout(async () => {
                        getDetailById(detailDataLocal.value.id);
                        currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.flowInfo.mipId, loginName: userCode });
                        clearTimeout(times);
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/customerIntroductionChangeFlow?customerCode=${detailDataLocal.value.customerCode}&id=${detailDataLocal.value.id}&type=update`;
            }
            return params;
        };
        // draft_submit分支处理
        const handleDraftSubmit = async (params) => {
            try {
                await handleApproveProcess(params);
                // }
            } catch (e) {
                btnloading.value = false;
            }
        };
        const scrollToHandle = () => {
            const elementRules = document.querySelector(`.customer-change-info`);
            const collapseRules = document.querySelector(`.customer-change-collapse`);
            setupContext.root.$nextTick(() => {
                elementRules.scrollTo({
                    // eslint-disable-next-line no-magic-numbers
                    top: collapseRules.getBoundingClientRect().height - Number(MAGIC_HEIGHT),
                    left: 0,
                    behavior: 'smooth' // 可选值：'auto'（默认）或'smooth'（平滑滚动）
                });
            });
        };
        const submitMip = async () => {
            const content = window;
            content.frames && content.frames.length && content.frames[0]
                && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
            content.frames && content.frames.length && content.frames[1]
                && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
            currentTime.value = new Date().getTime();
            store.commit('updateIflowPage', { pageTime: currentTime.value });
            scrollToHandle();
        };
        const currentTime = ref('');
        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            const params = prepareApproveParams(event.data);
            const processParam = params.processParam || {};
            btnloading.value = true;
            if (processParam.operationType === 'draft_submit') {
                await handleDraftSubmit(params);
                return;
            }
            handleApproveProcess(params);
        };
        const mipUrl = ref('');
        const newMip = ref(false);
        const handleCreate = () => {
            const { flowInfo, billCode } = detailDataLocal.value;
            const fdTemplateKey = 'CRM_customer_introduction_apply';
            mipUrl.value = '';
            // eslint-disable-next-line max-len, max-len
            mipUrl.value = `${configurl.iflowUrl}?customerChangeCode=${billCode}
            &fdId=${flowInfo.mipId}&fdTemplateKey=${fdTemplateKey}&userCode=${userCode}&userName=${userName}`;
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
            newMip.value && setTimeout(() => {
                const element = document.getElementsByClassName('customer-change-info')[0];
                // eslint-disable-next-line no-magic-numbers
                element.scrollTo(0, element.getBoundingClientRect().height - Number(MAGIC_HEIGHT)); // 页面滚动到MIP审批位置
                newMip.value = false;
            }, MAGIC_NUMBER.FOUR_HUNDRED);
        };
        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };
        const fileList = ref([]);
        const handleUpload = (res) => {
            if (res && +res.code === 0) {
                // 上传成功，获取文件列表
                getFileList();
            }
        };
        const getFileList = async () => {
            const params = {
                pageNo: 1,
                pageSize: 10000,
                userCode: detailDataLocal.value.applicantCode,
                relationId: detailDataLocal.value.id
            };
            await getEnclosurePage(params).then(res => {
                if (res && +res.code === 0) {
                    fileList.value = res.data || [];
                }
            });
        };
        const fileActions = (type, data) => {
            if (type === 'preview') {
                // 文件预览
                filePreview({
                    fileUrl: data.fileUrl,
                    fileName: data.fileName
                });
            } else if (type === 'download') {
                // 文件下载
                window.open(data.fileUrl);
            } else {
                // 文件删除
                const params = {
                    id: data.id
                };
                deleteEnclosure(params).then(async res => {
                    if (res && +res.code === 0) {
                        Message.success(`${data.fileName}文件删除成功！`);
                        await getFileList();
                    }
                });
            }
        };
        const handleFlow = async () => {
            // 提交审批
            if (['2', '3', '4', '7'].includes(detailDataLocal.value.approvalStatus) && !authorized.value) {
                Message.warning('客户引入申请单待审批/审判中/审批通过，禁止更新');
                return;
            }
            if (!detailDataLocal.value.billCode) {
                await handleSave();
            }
            if (detailDataLocal.value.id && !detailDataLocal.value.adminSpecialApproval && detailDataLocal.value.isSpecialApproval === '1') {
                const msg = adminAuth.value.join(',') || '';
                Message.warning(`海外业务引入触发特批,请联系${msg}`);
                return;
            }
            if (detailDataLocal.value.billCode) {
                await queryFlowByIntroduction({ billCode: detailDataLocal.value.billCode }).then(async res => {
                    if (res && +res.code === 0) {
                        newMip.value = true;
                        await _initData();
                    }
                });
            }
        };
        const saveDataFormat = (data) => {
            if (!data.routeCodes) {
                delete data.routeCodes;
            }
            delete data.ebcuEbplCountryName;
            delete data.ebcuEbplProvinceName;
            delete data.ebcuEbplCityName;
            delete data.ebcuDistrictsName;
            delete data.fileName;
            return data;
        };
        const handleSave = async (isSubmit) => {
            // 新增保存
            if (isSubmit !== true) { // 防止点击事件的回调event事件
                await setupContext.root.$nextTick();
            }
            if (['2', '3', '4', '7'].includes(detailDataLocal.value.approvalStatus)) {
                Message.warning('客户引入申请单待审批/审判中/审批通过，禁止更新');
                return;
            }
            const params = saveDataFormat(_.cloneDeep(detailDataLocal.value));
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            if (!data) return;
            if (+data.paymentTermDays > +data.creditPeriodDays) {
                Message.warning('账期天数不能大于总账期天数！');
                return;
            }; // 总账期小于账期
            saveLoading.value = isSubmit !== true;
            return addCustomerIntroduction(params).then(async (res) => {
                if (+res.code === 0) {
                    saveLoading.value = false;
                    Message.success('保存成功');
                    // 更新地址栏url参数
                    if (isSubmit === true) {
                        isHandleEdit.value = false;
                        // detailDataLocal.value.customerChangeCode = res.data || detailDataLocal.value.customerChangeCode;
                        oldDetailData.value = _.cloneDeep(detailDataLocal.value);
                        return;
                    };
                    const { origin, pathname } = window.location;
                    window.location.assign(`${origin}${pathname}#/customerIntroductionChangeFlow?customerCode=${detailDataLocal.value.customerCode}&id=${res.data.id}&type=update`);
                    await _initData();
                    // const tipsText = res.data.includes('CA') ? ',修改内容涉及关键信息，请填写修改原因后，发起流程审批，审批通过后信息才会修改' : '';
                    // comfirmDialog('保存成功' + tipsText, !!tipsText, res.data);
                } else {
                    saveLoading.value = false;
                }
            }).catch(() => {
                saveLoading.value = false;
            });
        };
        const toCustomerDetail = (code) => {
            ctx.$router.push({ path: '/mod/mdm/customer-manage', query: { customerCode: code } });
        };
        onActivated(() => {
            detailDataLocal.value = {};
            _initData();
            setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
        });
        return {
            config,
            detailLoading,
            btnloading,
            code,
            isShowBtn,
            submitFlowLoading,
            detailDataLocal,
            saveLoading,
            activeCollapses,
            mipUrl,
            handleInfosChange,
            handleFlow,
            handleSave,
            COLLAPSE,
            typeData,
            handleUpload,
            toCustomerDetail,
            dataChanged,
            fileList,
            submitMip,
            fileActions
        };
    }
};
</script>

<style lang="less" scoped>
@scrollbarThumbColor: rgba(0, 0, 0, .2);
@scrollbarThumbColorHover: rgba(0, 0, 0, .4);

.customer-cascader-select {
    width: 100%;
}

.address-custom {
    width: 100%;
}

.customer-mip-iframe {
    // overflow: auto;
    display: flex;
    flex-direction: column;

    .top-box {
        .header-box {
            width: 100%;

            h4 {
                text-align: center;
                font-size: 20px;
                margin: 0;
                color: #606266;
            }

            .header-info-crm {
                width: 100%;
                display: flex;
                font-size: 14px;
                border-bottom: 1px solid #dde0e6;
                margin-bottom: 10px;
                padding-bottom: 5px;
                justify-content: space-between;

                .tips {
                    flex: 1;
                    // color: red;
                    color: #606266;
                    line-height: 20px;
                }

                .apply-info {
                    line-height: 20px;
                    color: #606266;
                    margin-left: 10px;
                }
            }
        }

        .detail-toolBar {
            .item-flow-right {
                float: right;

                &.refresh {
                    margin-left: 10px;
                }
            }
        }
    }

    .customer-change-info {
        overflow: auto;

        .upload-demo {
            display: inline-block;
        }

        .down-mould-btn {
            margin-left: 5px;
        }

        .upload-tips {
            display: inline-block;
            margin-left: 10px;
            line-height: 28px;
            font-size: 12px;
            color: #606266;
        }

        .file-infos {
            width: 100%;
            padding: 0 10px 0 0;

            .file-list {
                width: 100%;
                padding: 2px 0 2px 4px;
                display: flex;

                // justify-content: space-between;
                .file-name {

                    // flex: 1;
                    &.upload {
                        width: 500px;
                    }

                    padding-right: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                }

                .view-btn,
                .delete-btn {
                    width: 200px;
                    display: flex;

                    a {
                        text-decoration: none;
                        color: #4285F5;
                    }

                    .el-button {
                        margin-left: 10px;
                    }

                    .el-button:focus,
                    .el-button:hover,
                    .el-button:active,
                    .el-button.is-disabled {
                        outline: none !important;
                        border-color: transparent !important;
                        /* 可选：如果要去除激活时的边框颜色变化 */
                    }
                }
            }
        }

        .el-collapse-item__content {
            padding-bottom: 5px;
        }

        .el-collapse-item__arrow {
            margin: 0 8px 0 5px;
        }

        .el-button.is-disabled.is-plain,
        .el-button.is-disabled.is-plain:focus,
        .el-button.is-disabled.is-plain:hover {
            border-color: #FFF;
        }

        .width-small {
            width: 340px;
        }

        .width-middle {
            width: 500px;
        }

        .width-large {
            width: 1200px;
        }

        .el-form-item--mini.el-form-item,
        .el-form-item--small.el-form-item {
            margin-bottom: 2px;
        }

        .el-col.el-col-23.form-item {
            .el-form-item.el-form-item--mini {
                margin-bottom: 18px;
            }
        }

        .el-collapse-item__header {
            height: 32px;
        }

        .detail-form-collapse {
            padding-right: 10px;
        }

        .score-config-item-box {
            .item-tittle {
                font-size: 14px;
                font-weight: 600;
                color: #606266;
                margin-left: 28px;
            }
        }

        .rating-score-list-box {
            .el-collapse {
                border-bottom: none;

                .el-collapse-item__header {
                    border-bottom: none;
                }

                .el-collapse-item__wrap {
                    border-bottom: none;
                }
            }
        }
    }

    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
    }

    .el-collapse-item__header {
        color: #606266;
        font-size: 14px;
        font-weight: 600;
    }

    .header-operation {
        margin-top: 10px;
    }

    .resistr-add {
        float: right;
        margin-bottom: 8px;
        margin-right: 8px;
    }

    .customer-name-edit {
        display: flex;

        .customer-name-text {
            flex: 0 0 auto;
            max-width: 400px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .customer-name-tips {
            margin: 0 3px;
        }

        .customer-name-input {
            flex: 1;
        }
    }

    .customer-text-area {
        color: #606266;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        margin-top: 6px;
        line-height: 1.2;
    }
}

.no-auth-reg {
    font-size: 16px;
    padding: 20px;
    background: #fff;
    width: 100%;
}

.my-tooltip-box {
    width: 800px;
}
.red-text{
    color: crimson;
}
.upload-box{
    margin-bottom: 10px;
}
.file-list-box{
    margin-bottom: 10px;
    .file-list{
        color: #4285f5;
        cursor: pointer;
    }
    .file-actions-btn{
        margin-left: 10px;
        span{
            margin: 0 5px;
            font-size: 12px;
            cursor: pointer;
            color: #4285f5;
        }
    }
}

</style>
